import React, {useId} from 'react';
import classNames from 'classnames';
import {Tooltip as MuiTooltip, TooltipProps} from '@mui/material';

import styles from './tooltip.module.scss';

interface Props {
  className?: string;
}

const Tooltip = ({className, children, ...remainingProps}: Props & TooltipProps) => {
  const descriptionId = useId();

  return (
    <>
      <MuiTooltip
        classes={{arrow: styles.arrow, tooltip: classNames(styles.tooltip, className)}}
        arrow
        {...remainingProps}
        enterTouchDelay={100}
        aria-label={undefined}
        aria-describedby={descriptionId}
      >
        {children}
      </MuiTooltip>
      <span id={descriptionId} className="sr-only">
        {remainingProps.title}
      </span>
    </>
  );
};

export default Tooltip;
